import { render, staticRenderFns } from "./IconsDialog.vue?vue&type=template&id=97f8c428&scoped=true&"
import script from "./IconsDialog.vue?vue&type=script&lang=js&"
export * from "./IconsDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconsDialog.vue?vue&type=style&index=0&id=97f8c428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f8c428",
  null
  
)

export default component.exports